import comp from "./GooglePicker";
export default comp;
